import { render, staticRenderFns } from "./ProductParameters.vue?vue&type=template&id=3e75f1fa&scoped=true&"
import script from "./ProductParameters.vue?vue&type=script&lang=js&"
export * from "./ProductParameters.vue?vue&type=script&lang=js&"
import style0 from "./ProductParameters.vue?vue&type=style&index=0&id=3e75f1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e75f1fa",
  null
  
)

export default component.exports